module.exports = {
	"data": {
		"markdownRemark": {
			"html": "<p>Given a view, <code>takeSnapshotAsync</code> will essentially screenshot that view and return an image for you. This is very useful for things like signature pads, where the user draws something and then you want to save an image from it.</p>\n<h3 id=\"exponenttakesnapshotasyncview-options\"><a href=\"#exponenttakesnapshotasyncview-options\" aria-hidden=\"true\"><span class=\"icon icon-link\"></span></a><code>Exponent.takeSnapshotAsync(view, options)</code></h3>\n<p>Snapshots the given view.</p>\n<h4 id=\"arguments\"><a href=\"#arguments\" aria-hidden=\"true\"><span class=\"icon icon-link\"></span></a>Arguments</h4>\n<ul>\n<li>\n<p><strong>view (<em>number|ReactElement</em>)</strong> — The <code>ref</code> or <code>reactTag</code> (also known as node handle) for the view to snapshot.</p>\n</li>\n<li>\n<p><strong>options (<em>object</em>)</strong> —</p>\n<p>  A map of options:</p>\n<ul>\n<li><strong>format (<em>string</em>)</strong> — <code>\"png\" | \"jpg\" | \"jpeg\" | \"webm\"</code></li>\n<li><strong>quality (<em>number</em>)</strong> — Number between 0 and 1 where 0 is worst quality and 1 is best.</li>\n<li><strong>result (<em>string</em>)</strong> — The type for the resulting image.\n-   <code>'file'</code> — Return a file uri.\n-   <code>'base64'</code> — base64 encoded image.\n-   <code>'data-uri'</code> — base64 encoded image with data-uri prefix.</li>\n<li><strong>height (<em>number</em>)</strong> — Height of result in pixels.</li>\n<li><strong>width (<em>number</em>)</strong> — Width of result in pixels.</li>\n</ul>\n</li>\n</ul>\n<h4 id=\"returns\"><a href=\"#returns\" aria-hidden=\"true\"><span class=\"icon icon-link\"></span></a>Returns</h4>\n<p>An image of the format specified in the options parameter.</p>",
			"excerpt": "Given a view,   will essentially screenshot that view and return an image for you. This is very useful for things like signature pads, where...",
			"frontmatter": {
				"title": "takeSnapshotAsync",
				"prev": {
					"fileSlug": "/v12.0.0/sdk/svg/",
					"children": [
						{
							"frontmatter": {
								"title": "Svg"
							}
						}
					]
				},
				"next": {
					"fileSlug": "/v12.0.0/sdk/util/",
					"children": [
						{
							"frontmatter": {
								"title": "Util"
							}
						}
					]
				}
			}
		}
	},
	"pathContext": {
		"fileSlug": "/v12.0.0/sdk/take-snapshot-async/"
	}
};


//////////////////
// WEBPACK FOOTER
// ./.intermediate-representation/json/v-12-0-0-sdk-take-snapshot-async.json
// module id = ./.intermediate-representation/json/v-12-0-0-sdk-take-snapshot-async.json
// module chunks = 109